import {
  AfterViewInit,
  Component,
  ComponentRef,
  inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { UserListAbstract } from '@base/abstracts/components/user-list.abstract';
import { ProfileAccess } from '@base/models/responses/profile-access.res';
import { DynamicImportLoaderService } from '@base/services/private/dynamic-import.service';
import { GlobalStateService } from '@base/services/private/global-state.service';
import { WhiteLabel } from '@config/whitelabel-keys.constant';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user',
  imports: [],
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
})
export class UserComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('userList', { read: ViewContainerRef }) userList!: ViewContainerRef;
  @Input() modalId = '';

  private readonly dynamicImportLoaderSrv = inject(DynamicImportLoaderService);
  private readonly globalStateSrv = inject(GlobalStateService);

  userListInstance: ComponentRef<unknown> | undefined;
  isShowPlaceholder = true;
  profileAccess!: ProfileAccess;
  globalState$: Subscription | null = null;

  ngOnInit(): void {
    this.getGlobalState();
  }

  ngAfterViewInit(): void {
    (async () => {
      await this.loadComponents();
    })();
  }

  ngOnDestroy(): void {
    if (this.globalState$) {
      this.globalState$.unsubscribe();
    }
  }

  getGlobalState(): void {
    this.isShowPlaceholder = true;
    this.globalState$ = this.globalStateSrv.getState$(true).subscribe({
      next: (state) => {
        if (state.profileAccess) {
          this.isShowPlaceholder = false;
          this.profileAccess = state.profileAccess;
        }
      },
    });
  }

  /**
   * Asynchronously loads components for the explore page.
   *
   * Ensures that necessary components are initialized and ready to use.
   *
   * @returns Promise<void> Resolves when all components are successfully loaded.
   */
  private async loadComponents(): Promise<void> {
    try {
      const components = await Promise.all([
        this.dynamicImportLoaderSrv.loadComponent(this.userList, WhiteLabel.COMPONENTS.UserList),
      ]);

      if (components) {
        const [userList] = components;

        this.userListInstance = userList?.componentRef || undefined;
        setTimeout(() => {
          this.renderUserList();
        }, 300);
      } else {
        throw new Error('Components could not be loaded.');
      }
    } catch (error) {
      console.error('Failed to load components:', error);
    }
  }

  /**
   * Render user list with assign data
   */
  renderUserList(): void {
    const userListInstance = this.userListInstance?.instance as UserListAbstract;
    if (userListInstance) {
      userListInstance.profileAccess = this.profileAccess;
      userListInstance.isShowPlaceholder = this.isShowPlaceholder;
      userListInstance.modalId = this.modalId;
    }
  }
}
